var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M5 8.999c0 1.902.765 3.627 2 4.89V21a.998.998 0 0 0 1.447.895L12 20.118l3.553 1.776a.99.99 0 0 0 .972-.043c.295-.183.475-.504.475-.851v-7.11a6.98 6.98 0 0 0 2-4.891C19 5.14 15.86 2 12 2S5 5.14 5 8.999m7.447 9.106a1 1 0 0 0-.895 0L9 19.382v-4.067A6.96 6.96 0 0 0 12 16c1.074 0 2.089-.25 3-.685v4.066zM12 4c2.756 0 5 2.242 5 4.999A5.006 5.006 0 0 1 12 14c-2.757 0-5-2.243-5-5.001A5.005 5.005 0 0 1 12 4"
})));
export default SvgReward;